module.exports = __webpack_public_path__ + "img/avatar.68f43081.jpg";